module.exports = __webpack_public_path__ + "static/media/Hero.2aac01e6.svg";